import React, { useCallback, useState } from 'react'
import Card from '../../../_library/Card'
import { getCountryCurrencies } from '../../../utils/coutriesUtils'
import Button from '../../../_library/Button'
import _get from 'lodash/get'
import _map from 'lodash/map'
import _forEach from 'lodash/forEach'
import _filter from 'lodash/filter'
import SortableTable from '../../../_library/SortableTable'
import { getTableColumns } from '../../../utils/sortableTableUtils'
import { addEventAdditionalCurrency } from '../../../../_common/core/http_services'
import { showAxiosError } from '../../../utils/messenger'
import AdditionalCurrencyModal from './AdditionalCurrencyModal'

const currencies = getCountryCurrencies()

const AdditionalCurrenciesCard = props => {
  const { values, event, setFieldValue } = props

  const [isModalOpen, setIsModalOpen] = useState(false)
  const [selected, setSelected] = useState(null)
  const [loadingDelete, setLoadingDelete] = useState({})

  const addAdditionalCurrency = useCallback(
    async currencies => {
      try {
        const res = await addEventAdditionalCurrency(event?.id, currencies)
        const newAdditionalCurrencies = _map(_get(res, 'attributes.additionalCurrencies') || [])
        setFieldValue('additionalCurrencies', newAdditionalCurrencies)
        setIsModalOpen(false)
      } catch (error) {
        showAxiosError(error)
      }
    },
    [event?.id, setFieldValue],
  )

  return (
    <Card icon={'fa-money'} title={'Additional Currencies'}>
      <div className="row">
        <div className="col-xs-12">
          <Button
            className="btn btn-success btn-shadow"
            type="button"
            onClick={() => {
              setSelected(null)
              setIsModalOpen(true)
            }}
          >
            <span>
              <i className="fa fa-plus" aria-hidden="true" /> Add Additional Currency
            </span>
          </Button>
          <AdditionalCurrencyModal
            values={values}
            isOpen={isModalOpen}
            handleCancel={() => {
              setIsModalOpen(false)
            }}
            handleSubmit={data => {
              const { additionalCurrency, ...restData } = data
              const currencyObj = currencies.find(item => item.value === additionalCurrency)
              const updatedAdditionalCurrencies = {}

              _forEach(values.additionalCurrencies, item => {
                updatedAdditionalCurrencies[item.currency.currency] = item
              })

              updatedAdditionalCurrencies[additionalCurrency] = { ...restData, currency: currencyObj.data }

              addAdditionalCurrency({
                data: {
                  attributes: {
                    additionalCurrencies: updatedAdditionalCurrencies,
                  },
                },
              })
            }}
            additionalCurrencies={values.additionalCurrencies}
            selected={selected}
          />
        </div>
      </div>
      {values?.additionalCurrencies?.length ? (
        <>
          <div className="div-spacing-20" />
          <SortableTable
            data={_map(values.additionalCurrencies, item => ({
              ...item,
              currency: item?.currency?.currency,
            }))}
            tableColumns={getTableColumns([
              'currency',
              'payment_method',
              { key: 'tax_class_id', normalizer: value => value || 'N/A' },
              { key: 'external_payment_provider', normalizer: value => value || 'N/A' },
            ])}
            enableSort={true}
            actions={[
              {
                label: 'Edit',
                className: 'btn btn-primary',
                icon: 'fa fa-pencil fa-fw',
                onClick: async data => {
                  setSelected(data)
                  setIsModalOpen(true)
                },
              },
              {
                label: 'Delete',
                className: 'btn btn-danger',
                icon: 'fa fa-trash fa-fw',
                onClick: async data => {
                  setLoadingDelete(currValue => ({
                    ...currValue,
                    [data.currency]: true,
                  }))

                  const { additionalCurrency, ...restData } = data
                  const updatedAdditionalCurrencies = {}

                  _forEach(
                    _filter(
                      values.additionalCurrencies,
                      item => item.currency.currency !== restData.currency,
                    ),
                    item => {
                      updatedAdditionalCurrencies[item.currency.currency] = item
                    },
                  )

                  addAdditionalCurrency({
                    data: {
                      attributes: {
                        additionalCurrencies: updatedAdditionalCurrencies,
                      },
                    },
                  }).then(() => {
                    setLoadingDelete(currValue => ({
                      ...currValue,
                      [data.currency]: false,
                    }))
                  })
                },
                isLoading: data => loadingDelete[data.currency],
                disabled: data => loadingDelete[data.currency],
              },
            ]}
          />
        </>
      ) : null}
    </Card>
  )
}

export default AdditionalCurrenciesCard
